import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "webRTCCreateAnswer";

function create({ sdp }) {
  const WebRTCCreateAnswerMessage = protoRoot.lookupType(
    `comm.WebRTCCreateAnswerMessage`
  );
  const webRTCCreateAnswerMessage = WebRTCCreateAnswerMessage.create({ sdp });

  return createMessage({ [name]: webRTCCreateAnswerMessage });
}

export default {
  create,
  name
};
